import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';

@Component({
  selector: 'app-fleetdiag-ecu-status',
  templateUrl: './fleetdiag-ecu-status.component.html',
  styleUrls: ['./fleetdiag-ecu-status.component.css', '../../fleetdiag-dashboard-pro.component.scss']
})
export class FleetdiagEcuStatusComponent implements OnInit {
  data: any = [];

  searchForm: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    strUnitID: new FormControl(''),
    iFleetDiag_SystemUser: new FormControl(''),
    source: new FormControl(''),
  });

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
  ) { }

  ngOnInit(): void {
    const { id } = this.route.snapshot.params;

    const isFleetUser = id.length < 15 && id.length > 3;
    const controlName = isFleetUser ? 'iFleetDiag_SystemUser' : 'strUnitID';

    this.searchForm.patchValue({
      [controlName]: id,
      source: isFleetUser ? 'users' : 'car-info'
    });

    this.fetchData().catch(err => {
      this._tooltip.showError('خطا در دریافت داده‌ها');
      console.error(err);
      this._otherService.nonespinner();
    });

  }

  async fetchData() {

    this._otherService.Showspinner()

    const model = this._otherService.stringNumberToNumber(this.searchForm.value);

    const endpoint =
      this.searchForm.value.source === 'users'
        ? 'FleetDiag_AnalyzeDTC4FleetDiag'
        : 'FleetDiag_AnalyzeDTC4FleetYar';

    const response = JSON.parse(
      (await axios.post(endpoint, model)).data.toString()
    );

    this._otherService.nonespinner();

    if (response.ISSessionExpired == true) {
      this._tooltip.showError('نشست کاربری شما منقضی شده است');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'DecodePid' } });
      return;
    }

    if (response.iResult == 0) {
      return this._tooltip.showError(response.strError);
    }

    this.data = response;
  }

  shareError(error: any): void {
    const shareText = `کد خطا: ${error.strCode}\n${error.strTitle}\n\n${error.strDescription}${error.strAdvice ? '\n\nراهکار: ' + error.strAdvice : ''}`;

    navigator.clipboard.writeText(shareText).then(() => {
      this._tooltip.showSuccess('اطلاعات خطا کپی شد!')
    }).catch(() => {
      this.fallbackCopyToClipboard(shareText);
    });
  }

  private fallbackCopyToClipboard(text: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      this._tooltip.showSuccess('اطلاعات خطا کپی شد!')
    } catch (err) {
      this._tooltip.showError('خطا در کپی کردن');
    }
    document.body.removeChild(textArea);
  }


}
